import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import Socket from './socket.svg';
import { ResponsiveIcon, } from 'console/shared/components/icon/responsive';
export const SocketsIcon = memo(forwardRef((props, ref) => {
    return _jsx(ResponsiveIcon, { ref: ref, Icon: Socket, ...props });
}));
SocketsIcon.displayName = 'SocketsIcon';
export { Socket };
